"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Minus = function Minus(props) {
  var className = props.className,
      style = props.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: className,
    style: style,
    fill: "currentColor",
    width: "12px",
    height: "2px",
    viewBox: "0 0 12 2",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Variant-3",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.0625,0.0625 L0.9375,0.0625 C0.419769281,0.0625 0,0.482269281 0,1 C0,1.51773072 0.419769281,1.9375 0.9375,1.9375 L11.0625,1.9375 C11.5802307,1.9375 12,1.51773072 12,1 C12,0.482269281 11.5802307,0.0625 11.0625,0.0625 Z",
    id: "minus",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Minus.propTypes = {
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
Minus.defaultProps = {
  className: undefined,
  style: undefined
};
var _default = Minus;
exports["default"] = _default;